<template>
    <div>
        <loader-component v-if="isLoader" />
        <template v-if="$route.path == '/login' || $route.name == 'user-login' || $route.name == 'support-chat' || $route.name == 'support-chat-new' || $route.name == 'user-chat-panel'">
            <router-view />
        </template>
        <template v-else-if="authData">
            <component :is="headerComponent"></component>
            <section class="chat-borad-wrapper">
                <div class="container-fluid borad-container">
                    <div class="chat-borad-con">
                        <component :is="sidebarComponent" ref="sidebarRef"></component>
                    </div>
                    <router-view :key="$route.fullPath" />
                </div>
            </section>
        </template>
    </div>
</template>

<script>
import LoaderComponent from './components/LoaderComponent.vue'
import { defineAsyncComponent } from "vue";
import { mapState } from 'vuex';
import notificationAlert from '@/helpers/notificationAlert';

export default {
    name: 'App',
    extends: notificationAlert,
    components: {
        'loader-component': LoaderComponent,
    },
    computed: {
        ...mapState([
            'isLoader', 'loggedIn', 'authData'
        ]),
        headerComponent() {
            return defineAsyncComponent(() => import(`@/components/HeaderComponent.vue`))
        },
        sidebarComponent() {
            return defineAsyncComponent(() => import(`@/components/SidebarComponent.vue`))
        }
    },
    mounted() {
        let path = window.location.pathname.split('/')[1];
        if (!localStorage.getItem('_token') && localStorage.getItem('_token') == null && path != 'user-login' && path != 'support-chat' && path != 'support-chat-new' && path != 'user-chat-panel') {
            this.$router.push('/login')
        }
        window.store = this.$store
        let notificationSubscribed = localStorage.getItem('notificationSubscribed')
        console.log(notificationSubscribed)
        setTimeout(()=>{
            if(this.authData?.status && notificationSubscribed != 1){
                this.requestNotificationPermission()
            }
        },100)
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    margin-top: 60px;
}
</style>
